/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M18.7101 10C18.8987 10.6337 19 11.305 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C13.9587 5 15.7295 5.80447 17 7.10102L16 4M11.5 14.5H14.5V12H11.5V9.5H14.5M9.5 9.5V14.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M18.7101 10C18.8987 10.6337 19 11.305 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C13.9587 5 15.7295 5.80447 17 7.10102L16 4M11.5 14.5H14.5V12H11.5V9.5H14.5M9.5 9.5V14.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM16.7138 3.76982C16.5867 3.37559 16.164 3.15907 15.7698 3.2862C15.3756 3.41332 15.1591 3.83596 15.2862 4.23018L15.5736 5.1215C14.5043 4.56488 13.2887 4.25 12 4.25C7.71979 4.25 4.25 7.71979 4.25 12C4.25 16.2802 7.71979 19.75 12 19.75C16.2802 19.75 19.75 16.2802 19.75 12C19.75 11.2318 19.638 10.4885 19.429 9.78606C19.3108 9.38906 18.8932 9.16301 18.4962 9.28116C18.0992 9.39931 17.8731 9.81693 17.9913 10.2139C18.1594 10.779 18.25 11.3782 18.25 12C18.25 15.4518 15.4518 18.25 12 18.25C8.54822 18.25 5.75 15.4518 5.75 12C5.75 8.54822 8.54822 5.75 12 5.75C13.749 5.75 15.3291 6.46742 16.4643 7.62594C16.7078 7.87441 17.0902 7.92284 17.3879 7.74291C17.6856 7.56297 17.8206 7.20192 17.7138 6.87083L16.7138 3.76982ZM10.25 9.5C10.25 9.08579 9.91421 8.75 9.5 8.75C9.08579 8.75 8.75 9.08579 8.75 9.5V14.5C8.75 14.9142 9.08579 15.25 9.5 15.25C9.91421 15.25 10.25 14.9142 10.25 14.5V9.5ZM11.5 8.75C11.0858 8.75 10.75 9.08579 10.75 9.5V12C10.75 12.4142 11.0858 12.75 11.5 12.75H13.75V13.75H11.5C11.0858 13.75 10.75 14.0858 10.75 14.5C10.75 14.9142 11.0858 15.25 11.5 15.25H14.5C14.9142 15.25 15.25 14.9142 15.25 14.5V12C15.25 11.5858 14.9142 11.25 14.5 11.25H12.25V10.25H14.5C14.9142 10.25 15.25 9.91421 15.25 9.5C15.25 9.08579 14.9142 8.75 14.5 8.75H11.5Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 14.5L2 15V15C2 16.8613 2 17.7919 2.24472 18.5451C2.73931 20.0673 3.93273 21.2607 5.45491 21.7553C6.20808 22 7.13872 22 9 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2L9 2C7.13872 2 6.20808 2 5.45491 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9V9L2 9.5M18.7101 10C18.8987 10.6337 19 11.305 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C13.9587 5 15.7295 5.80447 17 7.10102L16 4M11.5 14.5H14.5V12H11.5V9.5H14.5M9.5 9.5V14.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M18.7101 10C18.8987 10.6337 19 11.305 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C13.9587 5 15.7295 5.80447 17 7.10102L16 4M11.5 14.5H14.5V12H11.5V9.5H14.5M9.5 9.5V14.5M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.7698 3.28615C16.164 3.15903 16.5867 3.37555 16.7138 3.76977L17.7138 6.87079C17.8206 7.20188 17.6856 7.56293 17.3879 7.74286C17.0902 7.92279 16.7078 7.87437 16.4643 7.6259C15.3291 6.46737 13.749 5.74996 12 5.74996C8.54822 5.74996 5.75 8.54818 5.75 12C5.75 15.4517 8.54822 18.25 12 18.25C15.4518 18.25 18.25 15.4517 18.25 12C18.25 11.3782 18.1594 10.7789 17.9913 10.2139C17.8731 9.81689 18.0992 9.39927 18.4962 9.28112C18.8932 9.16296 19.3108 9.38902 19.429 9.78602C19.638 10.4884 19.75 11.2318 19.75 12C19.75 16.2802 16.2802 19.75 12 19.75C7.71979 19.75 4.25 16.2802 4.25 12C4.25 7.71975 7.71979 4.24996 12 4.24996C13.2887 4.24996 14.5043 4.56484 15.5736 5.12146L15.2862 4.23014C15.1591 3.83592 15.3756 3.41328 15.7698 3.28615ZM9.5 8.74996C9.91421 8.74996 10.25 9.08574 10.25 9.49996V14.5C10.25 14.9142 9.91421 15.25 9.5 15.25C9.08579 15.25 8.75 14.9142 8.75 14.5V9.49996C8.75 9.08574 9.08579 8.74996 9.5 8.74996ZM10.75 9.49996C10.75 9.08574 11.0858 8.74996 11.5 8.74996H14.5C14.9142 8.74996 15.25 9.08574 15.25 9.49996C15.25 9.91417 14.9142 10.25 14.5 10.25H12.25V11.25H14.5C14.9142 11.25 15.25 11.5857 15.25 12V14.5C15.25 14.9142 14.9142 15.25 14.5 15.25H11.5C11.0858 15.25 10.75 14.9142 10.75 14.5C10.75 14.0857 11.0858 13.75 11.5 13.75H13.75V12.75H11.5C11.0858 12.75 10.75 12.4142 10.75 12V9.49996Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
